import { Auth } from '@aws-amplify/auth';

export const SignIn: React.FC = () => {
  return <div>{Auth.federatedSignIn()}</div>;
};

export default SignIn;
